import { Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { IcfBarPercentComponent } from '../../../../components/icf-bar-percent/icf-bar-percent.component';
import { IcfBarComponent } from '../../../../components/icf-bar/icf-bar.component';
import { IcfBoxLargeComponent } from '../../../../components/icf-box-large/icf-box-large.component';
import { NoteEditDialogComponent } from '../../../../dialogs/note-edit-dialog/note-edit-dialog.component';
import { IcfDescriptionPipe } from '../../../../pipes/icf-description.pipe';
import { ReportItemDetailsAggregationPipe } from '../../../../pipes/report-item-details-aggregation.pipe';
import { AssessmentsService } from '../../../../services/assessments.service';
import { icfCategoryDescriptions } from '../../../../services/de';
import { IcfCategory, ReportItem, icfCategoryLabels } from '../../../../services/model';
import { ReportDetailRowComponent } from '../report-detail-row/report-detail-row.component';

@Component({
  selector: 'app-report-row',
  standalone: true,
  imports: [
    ReportDetailRowComponent,
    MatIconModule,
    MatButtonModule,
    IcfBarComponent,
    IcfBarPercentComponent,
    IcfDescriptionPipe,
    NoteEditDialogComponent,
    IcfBarComponent,
    IcfBoxLargeComponent,
    ReportItemDetailsAggregationPipe,
  ],
  templateUrl: './report-row.component.html',
  styleUrl: './report-row.component.scss',
})
export class ReportRowComponent {
  @Input() item!: ReportItem;
  @Input() isCategoryDesciptionEnabled!: boolean;

  showDetails: boolean = false;

  public dialog: MatDialog = inject(MatDialog);
  private readonly assessmentService: AssessmentsService = inject(AssessmentsService);

  icfCategoryLabels: { [key in IcfCategory]: string } = icfCategoryLabels;
  icfCategoryDescription = icfCategoryDescriptions;

  // getRandom() {
  //   return Math.floor(Math.random() * 100);
  // }

  editCustomNote(reportItem: ReportItem) {
    console.log('editCustomNote ', reportItem);
    const dialogRef = this.dialog.open(NoteEditDialogComponent, {
      data: {
        reportItem,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'speichern') {
        this.assessmentService.createOrUpdateReportNote({
          note: reportItem.customNote,
          icfCategory: reportItem.icfCategory,
        });
      }
    });
  }

  openNoteEditDialog() {}
}
